import {
  Box,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputBase,
  TextField,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { ReactComponent as IconTooltip } from "../../assets/svg/help-circle.svg";
import { ReactComponent as IconReload } from "../../assets/svg/reload.svg";
import {
  validateDockingStations,
  validateInputMinMaxArea,
  validateInputNum,
} from "../../utils/input-validations";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../services/api/api";
import { usePlannerContext } from "../../services/context/planner-context";
import { TooltipCustom, TooltipWithIconCustom } from "./tooltip-custom";

const CustomInput = styled(TextField)(({ theme, small, error }) => ({
  /* "label + &": {
    marginTop: "20px",
  }, */
  "& .MuiInputBase-root": {
    borderRadius: small ? 6 : 8,
    position: "relative",
    backgroundColor: "#fff",
    border: "1px solid",
    borderColor: error ? theme.palette.error.main : "#dbdbeb",
    fontSize: 14,
    lineHeight: 18,
    width: "100%",
    padding: small ? "4px 8px" : "8px",
    transition: theme.transitions.create(["border-color", "background-color"]),
    input: {
      padding: 0,
    },
    fieldset: {
      border: "none",
    },
    "&.Mui-focused": {
      border: "1px solid",
      borderColor: theme.palette.primary.main,
    },
    "&:hover": {
      backgroundColor: "#fff",
      borderColor: theme.palette.primary.main,
    },
    /*  "&::placeholder": {
      color: "#e0e0e0",
      fontSize: "12px",
      opacity: 1,
    }, */
  },
  /*  "& .MuiInputBase-root": {
    borderRadius: small ? 6 : 8,
    position: "relative",
    backgroundColor: "#fff",
    border: "1px solid",
    borderColor: error ? theme.palette.error.main : "#dbdbeb",
    fontSize: 14,
    lineHeight: 18,
    width: "100%",
    padding: small ? "4px 8px" : "8px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
    ]),
    "&:focus": {
      borderColor: theme.palette.primary.main,
    },
    "&:hover": {
      backgroundColor: "#fff",
      borderColor: theme.palette.primary.main,
    },
    "&::placeholder": {
      color: "#e0e0e0",
      fontSize: "12px",
      opacity: 1,
    },
  }, */
}));

export const TextFieldStr = ({
  label,
  unit,
  placeholder,
  tooltip = "",
  requier = false,
  value,
  setValue,
  small = false,
  name = "",
  isNumber = true,
  min = 0,
  max = null,
  area,
  shouldBeInteger = false,
  alternative = false,
  setAlternativeInputsEmpty,
  alternativeInputsEmpty,
  minArea = null,
  maxArea = null,
  secondArea,
  setDisplayTruckRequirement,
  truckRequirement,
  disabled = false
}) => {
  const { validateStart, setValidateEnd, setErrors, property } =
    usePlannerContext();
  const [currentValue, setCurrentValue] = useState(
    value === null || value === undefined || value === -1
      ? ""
      : value.toString()
  );
  const [errorArea, setErrorArea] = useState(null);
  const [errorHeight, setErrorHeight] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorAPI, setErrorAPI] = useState(false); /* 
  const [errorAlternative, setErrorAlternative] = useState(false); */

  const validateBuildHeight = (valueNum) => {
    if (
      name === "height" &&
      valueNum > 0 &&
      valueNum + 2 > Number(property.maxConstrHeight)
    ) {
      setErrorHeight(
        `Value (${valueNum + 2} m) exceeds the maximum construction height (${
          property.maxConstrHeight
        } m).`
      );
    } else if (
      name === "stories" &&
      valueNum > 0 &&
      valueNum * 3 + 2 > Number(property.maxConstrHeight)
    ) {
      setErrorHeight(
        `Value (${
          valueNum * 3 + 2
        } m) exceeds the maximum construction height (${
          property.maxConstrHeight
        } m).`
      );
    } else {
      setErrorHeight(null);
    }
  };

  // set value
  const setValueHandler = (val) => {
    const valueNum = val !== "" ? Number(val) : -1;
    const inputError =
      val !== ""
        ? validateInputNum(val, min, max, unit, shouldBeInteger)
        : null;

    if ((name === "height" || name === "stories") && property && !inputError) {
      validateBuildHeight(valueNum);
    }

    let docksError = null;
    if (name === "numDocks" && !inputError) {
      docksError = validateDockingStations(valueNum, minArea, truckRequirement);
    }

    setError(inputError ? inputError : docksError);
    setCurrentValue(val);
    if (name === "numDocks" && !inputError) {
      setDisplayTruckRequirement(val && val > 0);
      /* if(!val && val <= 0){
        setValue(-1, 'truckRequirement');
      } */
    }
  };

  // handle input change
  const handleChange = (e) => {
    const val = e.target.value.trim().replace(",", ".");
    if (isNumber) {
      setValueHandler(val);
    } else {
      setCurrentValue(val);
    }
    if (alternative && val !== "") {
      setAlternativeInputsEmpty(false);
      /* setErrorAlternative(false); */
    }
    setErrorAPI(false);
  };

  const updateBuilding = async (buildingId, buildingInputs) => {
    setLoading(true);
    setErrorAPI(null);
    try {
      const response = await axiosInstance.put(
        `/buildings/updateBuilding/${buildingId}`,
        buildingInputs
      );
    } catch (error) {
      // Handle error
      setErrorAPI(true);
    } finally {
      setLoading(false);
    }
  };

  const onBlurHandler = (e) => {
    const valueNum = currentValue !== "" ? Number(currentValue) : -1;

    let areaError = null;
    if (
      (name === "rangeMax" || name === "rangeMin") &&
      currentValue !== "" &&
      currentValue !== -1 &&
      !error &&
      (minArea || maxArea)
    ) {
      areaError = validateInputMinMaxArea(currentValue, unit, minArea, maxArea);
      setErrorArea(areaError);
    }

    if (
      area &&
      area.buildingId &&
      !error /* && !areaError */ &&
      value !== valueNum
    ) {
      let buildingInputs;
      setValue(valueNum, name);
      if (name === "numDocks") {
        if (valueNum === -1 || valueNum === 0) {
          setValue(-1, "truckRequirement");
          buildingInputs = {
            ...area.building,
            [name]: valueNum,
            truckRequirement: -1,
          };
        } else {
          setValue(truckRequirement, "truckRequirement");
          buildingInputs = {
            ...area.building,
            [name]: valueNum,
            truckRequirement: truckRequirement,
          };
        }
      } else {
        buildingInputs = {
          ...area.building,
          [name]: valueNum,
        };
      }

      updateBuilding(area.buildingId, buildingInputs);
    }
  };

  const reloadHandler = () => {
    const valueNum = currentValue !== "" ? Number(currentValue) : -1;

    if (area && area.buildingId && !error) {
      const buildingInputs = {
        ...area.building,
        [name]: valueNum,
      };

      updateBuilding(area.buildingId, buildingInputs);
    }
  };

  useEffect(() => {
    const valueNum = currentValue !== "" ? Number(currentValue) : -1;
    if ((name === "height" || name === "stories") && property && !error) {
      validateBuildHeight(valueNum);
    }
  }, []);

  useEffect(() => {
    if (name === "numDocks" && currentValue !== "" && currentValue !== -1) {
      const valueNum = currentValue !== "" ? Number(currentValue) : -1;
      const docksError = validateDockingStations(valueNum, minArea, truckRequirement);
      setError(docksError);
    }

    if (
      (name === "rangeMax" || name === "rangeMin") &&
      currentValue !== "" &&
      currentValue !== -1
    ) {
      const inputError = validateInputNum(currentValue, min, max, unit, shouldBeInteger);
      setError(inputError);
    }
  }, [minArea, truckRequirement]);

  useEffect(() => {
    if (validateStart > 0) {
      if (!!error || errorAPI || !!errorArea || !!errorHeight) {
        setErrors((prev) => prev + 1);
      } else if (requier && currentValue === "") {
        setError("This field is required and cannot be empty.");
        setErrors((prev) => prev + 1);
      } else if (alternative && currentValue === "") {
        setAlternativeInputsEmpty(true);
        /* if(alternativeInputsEmpty){
          setErrorAlternative(true);
        } */
      }
      setValidateEnd((prev) => prev + 1);
    }
  }, [validateStart]);

  useEffect(() => {
    let areaError = null;
    if (
      (name === "rangeMax" || name === "rangeMin") &&
      currentValue !== "" &&
      currentValue !== -1 &&
      /* !error && */
      (minArea || maxArea)
    ) {
      areaError = validateInputMinMaxArea(currentValue, unit, minArea, maxArea);
      setErrorArea(areaError);
    }
  }, [secondArea]);

  const setErrorBorder = alternative
    ? !!error || errorAPI || (validateStart > 0 && alternativeInputsEmpty)
    : !!error || errorAPI || !!errorArea || !!errorHeight;

  const currentValueNum = currentValue !== "" ? Number(currentValue) : -1;

  const displayAdornment =
    currentValueNum > 0 && (name === "height" || name === "stories");

  const calculatedHeight =
    name === "height"
      ? currentValueNum + 2
      : name === "stories"
      ? currentValueNum * 3 + 2
      : 0;

  return (
    <Box>
      <FormControl
        error={setErrorBorder}
        variant="standard"
        sx={{ width: "100%" }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "2px",
            /* mb: "4px", */
            padding: "0px 0px 0px 8px",
          }}
        >
          {/*           <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          > */}

          <TooltipWithIconCustom text={tooltip}>
            <Typography
              sx={{
                fontSize: "12px",
                color: "#343745",
                fontWeight: 500,
                lineHeight: 1.9,
              }}
            >
              {label}{" "}
              {unit && <span style={{ color: "#a2a3a3" }}>[{unit}]</span>}{" "}
              {requier && "*"}
            </Typography>
            {/* <IconTooltip width="14px" height="14px" stroke="#dbdbeb" /> */}
          </TooltipWithIconCustom>
          {/*  </Box> */}
          {loading && <CircularProgress size={15} />}
          {errorAPI && (
            <IconButton sx={{ padding: "4px" }} onClick={reloadHandler}>
              <IconReload stroke="#ba1a1a" width={"14px"} height={"14px"} />
            </IconButton>
          )}
        </Box>
        <CustomInput
          value={currentValue}
          onChange={handleChange}
          error={setErrorBorder}
          placeholder={placeholder}
          name={name}
          onBlur={onBlurHandler}
          autoComplete="off"
          slotProps={{
            input: {
              endAdornment: displayAdornment ? (
                <InputAdornment position="end">
                  <Typography fontSize={12}>
                    {name === "stories" && "* 3"} + 2 = {calculatedHeight} m
                  </Typography>
                </InputAdornment>
              ) : null,
            },
          }}
          disabled={disabled}
        />
        {(error || errorArea || errorHeight) && (
          <FormHelperText sx={{ pl: "8px" }} id="component-error-text">
            {error ? error : errorArea ? errorArea : errorHeight}
          </FormHelperText>
        )}
        {errorAPI && (
          <FormHelperText sx={{ pl: "8px" }} id="component-error-text">
            Failed to save the value. Please click the reload button (
            {<IconReload stroke="#ba1a1a" width={"10px"} height={"10px"} />})
            {/*  to
            try again. */}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};
